export const ALCOHOL_VOLUME_THRESHOLD = 10;
export const COMPANY_NAME = 'Makro PRO';

export const MAX_QUANTITY_ULTRA_FRESH_OOS = 99999;
export const MAKNET = 'Maknet';
export const PRODUCT_ID_PREFIX = 'gid://shopify/Product/';

export const THAI_PHONE_PREFIX = '+66';

export const zIndexes = {
  zIndexOne: 1,
  zIndexTwo: 2,
  zIndexThree: 3,
  zIndexSeven: 7,
  zIndexTen: 10,
  basketDrawer: 100,
  backdrop: 1000,
  header: 1200,
  accountPopper: 1500,
  StyledTooltip: 10000,
  SearchSuggestionsContainer: 999999,
  SearchInputBoxPopper: 9999999,
  productQuantityModal: 99999999,
  maxQuantityReached: 999999999,
  weightedFreshInfoModal: 999999999
};

export enum AvailableLanguageTypes {
  ENGLISH = 'en',
  THAI = 'th'
}

export const EMAIL_REGEX_V2 = new RegExp(
  // eslint-disable-next-line no-control-regex
  /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi
);

export const PHONE_REGEX_WITH_PASTE_ENABLED = /^(0[689][\d])\s?([\d]{3})\s?([\d]{4})$/;

export const THAI_ADDRESS_BRANCH_ID_REGEX = /^([\d]{5}$)/;

export const THAI_ADDRESS_TAX_ID_REGEX = /^([\d]{13}$)/;

// Thai as default langage
export const DEFAULT_LANGUAGE = AvailableLanguageTypes.THAI;

export enum SubDistrictStatusType {
  DELIVERABLE = 'DELIVERABLE',
  NOT_DELIVERABLE = 'NOT_DELIVERABLE',
  SOON = 'SOON'
}

export const PROMOTION_LITE_UNIT_DISCOUNT = 'unitDiscountAmt';
export const PROMOTION_LITE_IS_DROPSHIPMENT = 'isDropShipment';

export enum AppMode {
  regular = 'regular',
  express = 'express',
  storePickup = 'store_pickup'
}
